import Vue from 'vue'
const axios = require('axios')

export const sendAction = {
  methods: {
    async sendAction (type, id, name) {
      let uuId = localStorage.getItem('getUuid')
      let ask = {
        action: type,
        action_id: id,
        action_name: name,
        uid: this.$userUid ? this.$userUid : uuId,
        user_id: this.ask.user_id,
        brand: this.ask.brand
      }
      if (type === 'btn_back') {
        ask = {
          action: type,
          uid: this.$userUid ? this.$userUid : uuId
        }
      }
      Vue.prototype.$lastClick = new Date()
      try {
        return axios
          .post(`${this.ask.url}/api/ask/${this.settings.api_salt}/set-statistic-action`, {ask})
      } catch (e) {
        return e
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/sendAction.js